export const getDataForShipping = (shipping) =>
	shipping.status_delivered_at || shipping.status_delivered_no_payment_at;
